import { nikaoColors } from '../theme/nikaoTheme';
import html2canvas from 'html2canvas';


// Format number with commas
export const formatNumber = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0';
  }
  return Number(value).toLocaleString();
};

// Format currency - round to nearest pound for board reports
export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '£0';
  }
  
  const numValue = Number(value);
  
  // Round to nearest pound (no decimal places)
  const roundedValue = Math.round(numValue);
  
  return `£${roundedValue.toLocaleString()}`;
};

// Format percentage
export const formatPercentage = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0.0%';
  }
  return `${Number(value).toFixed(1)}%`;
};

// Format Nikao percentage with error handling
export const formatNikaoPercentage = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0.0%';
  }
  try {
    return `${Number(value).toFixed(1)}%`;
  } catch (error) {
    return '0.0%';
  }
};

// Nikao logo as data URL for easy positioning
const nikaoLogoDataUrl = "data:image/svg+xml;base64,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";

// Render Nikao logo as positioned image element
export const renderNikaoLogoBottomLeft = () => {
  return (
    <foreignObject x="10" y="420" width="60" height="20">
      <img 
        src={nikaoLogoDataUrl} 
        alt="Nikao Logo" 
        style={{ 
          width: '60px', 
          height: '20px',
          objectFit: 'contain'
        }} 
      />
    </foreignObject>
  );
};

// Render Nikao logo aligned with legends (left corner)
export const renderNikaoLogoWithLegends = () => {
  return (
    <foreignObject x="10" y="450" width="60" height="20">
      <img 
        src={nikaoLogoDataUrl} 
        alt="Nikao Logo" 
        style={{ 
          width: '60px', 
          height: '20px',
          objectFit: 'contain'
        }} 
      />
    </foreignObject>
  );
};

// Direct container download function - simpler and more reliable
export const downloadChartWithLogo = (chartId, filename, chartTitle = '') => {
  return new Promise((resolve, reject) => {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) {
      reject(new Error('Chart element not found'));
      return;
    }

    // Wait a bit for any animations to complete
    setTimeout(() => {
      try {
        // Use html2canvas directly on the chart container with minimal configuration
        html2canvas(chartElement, {
          backgroundColor: '#ffffff',
          scale: 2, // Good quality without being too large
          useCORS: true,
          allowTaint: true,
          logging: false,
          width: chartElement.offsetWidth,
          height: chartElement.offsetHeight,
          scrollX: 0,
          scrollY: 0
        }).then(canvas => {
          try {
            // Create a new canvas with extra space for title at the top
            const titleHeight = chartTitle ? 60 : 0;
            const finalCanvas = document.createElement('canvas');
            finalCanvas.width = canvas.width;
            finalCanvas.height = canvas.height + titleHeight;
            const ctx = finalCanvas.getContext('2d');
            
            // Fill with white background
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
            
            // Draw title at the top center if provided
            if (chartTitle) {
              ctx.fillStyle = '#1f2937';
              ctx.font = 'bold 24px Roboto, Helvetica, Arial, sans-serif';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText(chartTitle, finalCanvas.width / 2, 30);
            }
            
            // Draw the original chart below the title
            ctx.drawImage(canvas, 0, titleHeight);
            
            // Download the image directly
            const link = document.createElement('a');
            link.download = `${filename}_${new Date().toISOString().split('T')[0]}.png`;
            link.href = finalCanvas.toDataURL('image/png');
            link.click();
            
            resolve();
          } catch (error) {
            console.error('Error downloading chart:', error);
            reject(error);
          }
        }).catch(error => {
          console.error('Error capturing chart:', error);
          reject(error);
        });
      } catch (error) {
        console.error('Error setting up chart capture:', error);
        reject(error);
      }
    }, 500); // Shorter delay since we're not manipulating DOM
  });
};

// Simple fallback download function
export const downloadChartAsImage = (chartId, filename) => {
  const chartElement = document.getElementById(chartId);
  if (chartElement) {
    // Create a simple screenshot using the browser's built-in functionality
    try {
      // Use a simple approach - just capture the visible area
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Set canvas size to match the chart element
      canvas.width = chartElement.offsetWidth;
      canvas.height = chartElement.offsetHeight;
      
      // Fill with white background
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // Try to draw the chart element
      const data = `<svg xmlns="http://www.w3.org/2000/svg" width="${canvas.width}" height="${canvas.height}">
        <foreignObject width="100%" height="100%">
          <div xmlns="http://www.w3.org/1999/xhtml">
            ${chartElement.outerHTML}
          </div>
        </foreignObject>
      </svg>`;
      
      const img = new Image();
      img.onload = () => {
        ctx.drawImage(img, 0, 0);
      const link = document.createElement('a');
      link.download = `${filename}_${new Date().toISOString().split('T')[0]}.png`;
        link.href = canvas.toDataURL('image/png');
      link.click();
      };
      
      img.src = 'data:image/svg+xml;base64,' + btoa(data);
    } catch (error) {
      console.error('Simple download failed:', error);
      // Last resort - just show a message
      alert('Download functionality is not available. Please use browser screenshot or print functionality.');
    }
  }
};

// Nikao theme colors for charts
export const nikaoChartColors = {
  primary: nikaoColors.primary,
  secondary: nikaoColors.secondary,
  forecast: nikaoColors.forecast,
  actual: nikaoColors.actual,
  background: nikaoColors.background,
  text: nikaoColors.text,
  textSecondary: nikaoColors.textSecondary,
  border: nikaoColors.border,
  success: nikaoColors.success,
  error: nikaoColors.error,
  warning: nikaoColors.warning,
  info: nikaoColors.info
};

// Common chart configuration with Nikao theme
export const getNikaoChartConfig = (title, xAxisTitle, yAxisTitle) => ({
  colors: [nikaoColors.primary, nikaoColors.secondary, nikaoColors.forecast, nikaoColors.actual],
  chart: {
    backgroundColor: nikaoColors.background,
    style: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      color: nikaoColors.text
    }
  },
  title: {
    text: title,
    style: {
      color: nikaoColors.text,
      fontSize: '16px',
      fontWeight: '600'
    }
  },
  xAxis: {
    title: {
      text: xAxisTitle,
      style: {
        color: nikaoColors.textSecondary,
        fontSize: '12px',
        fontWeight: '500'
      }
    },
    labels: {
      style: {
        color: nikaoColors.textSecondary,
        fontSize: '11px'
      }
    },
    lineColor: nikaoColors.border,
    tickColor: nikaoColors.border
  },
  yAxis: {
    title: {
      text: yAxisTitle,
      style: {
        color: nikaoColors.textSecondary,
        fontSize: '12px',
        fontWeight: '500'
      }
    },
    labels: {
      style: {
        color: nikaoColors.textSecondary,
        fontSize: '11px'
      }
    },
    gridLineColor: nikaoColors.border
  },
  legend: {
    itemStyle: {
      color: nikaoColors.text,
      fontSize: '11px',
      fontWeight: '500'
    },
    itemHoverStyle: {
      color: nikaoColors.primary
    }
  },
  tooltip: {
    backgroundColor: nikaoColors.surface,
    borderColor: nikaoColors.border,
    style: {
      color: nikaoColors.text
    }
  },
  plotOptions: {
    series: {
      borderWidth: 0,
      borderRadius: 0
    }
  }
}); 